export const INVOPOP_ADAPTER_BASE = '/invopop-adapter/v1/suppliers'
export const INVOPOP_ADAPTER_INVOICES_BASE = '/invopop-adapter/v1/invoices'

export function invopopSupplierRegistrationPath (businessId: number | string): string {
  return `${INVOPOP_ADAPTER_BASE}/${encodeURIComponent(String(businessId))}/registration`
}

export function invopopInvoicesPath (businessId: number | string): string {
  return `${INVOPOP_ADAPTER_INVOICES_BASE}/${encodeURIComponent(String(businessId))}`
}

export function invopopInvoiceCorrectionPath (
  businessId: number | string,
  invoiceId: number | string
): string {
  return `${INVOPOP_ADAPTER_INVOICES_BASE}/${encodeURIComponent(String(businessId))}/correct/${encodeURIComponent(String(invoiceId))}`
}
